module.exports = __webpack_public_path__ + "img/strategy-03.8f3e25ab.svg";